export default __webpack_public_path__ + "static/media/trator.340ed506.png";